var map = {
	"./cn": [
		"d8f5"
	],
	"./cn.js": [
		"d8f5"
	],
	"./en": [
		"aeb6",
		"lang-en"
	],
	"./en.js": [
		"aeb6",
		"lang-en"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7457";
module.exports = webpackAsyncContext;